export enum CommentKindEnum {
	general = 1,
	internal = 2,
	system = 3
}